import React, { useState } from "react";
import {
  Editor,
  BtnBold,
  BtnItalic,
  ContentEditableEvent,
  createButton,
  EditorProvider,
  Toolbar,
  BtnBulletList,
  BtnStyles,
} from "react-simple-wysiwyg";
import { ReportWidgetProps } from "../ReportWidgetProps";
import s from "./TextEditorWidget.module.scss";
import { AlignCenter } from "./assets/AlignCenter";
import { AlignLeft } from "./assets/AlignLeft";
import { AlignRight } from "./assets/AlignRight";
import { useReportBespoke } from "@iliotech/data-wire";
import { observer } from "mobx-react-lite";
import parse from "html-react-parser";
import classNames from "classnames";

const BtnAlignCenter = createButton(
  "Align center",
  <AlignCenter />,
  "justifyCenter"
);
const BtnAlignLeft = createButton("Align left", <AlignLeft />, "justifyLeft");
const BtnAlignRight = createButton(
  "Align right",
  <AlignRight />,
  "justifyRight"
);

export const TextEditorWidget = observer(
  ({ height, isHalfWidth, width }: ReportWidgetProps) => {
    const [html, setHtml] = useState("");
    const { generating } = useReportBespoke();

    const styles = {
      height,
      width,
      maxHeight: height,
      minHeight: height,
    };
    function onChange(e: ContentEditableEvent) {
      setHtml(e.target.value);
    }

    if (generating) {
      return (
        <div style={styles} className={classNames(s.container, s.plainText)}>
          {parse(html)}
        </div>
      );
    }

    return (
      <EditorProvider>
        <div className={s.container}>
          <Editor style={styles} value={html} onChange={onChange}>
            <Toolbar>
              <BtnBold />
              <BtnItalic />
              <BtnBulletList />
              <BtnAlignLeft />
              <BtnAlignCenter />
              <BtnAlignRight />
              <BtnStyles />
            </Toolbar>
          </Editor>
        </div>
      </EditorProvider>
    );
  }
);
